import { useRef } from 'react';
import { Select } from 'antd';
import { useOperatorStore } from '../../store/useOperatorStore';
import { useGetSelectOperator } from '../../Pages/operators/Hooks';
import db from '../../../db';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const SelectOperatorDropdown = () => {
  const dropdownRef = useRef(null);
  const { operatorId, setOperatorID } = useOperatorStore(); // Use operatorId and name from zustand
  const { data: operatorData, isLoading } = useGetSelectOperator();
  const location = useLocation();
  const { t } = useTranslation('SelectClientDropdown');

  // Define all paths where operator switching should be disabled
  const restrictedPaths = ['/dashboard/customers/'];

  // Check if current path starts with any of the restricted paths
  const isRestrictedPage = restrictedPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  // Handle operator selection
  const handleSelectionChange = async (value) => {
    if (isRestrictedPage) return; // Prevent changing operator on restricted pages

    if (value === '1') {
      await db.operator.clear();
      setOperatorID(null, null);
    } else {
      const selectedOperator = operatorData?.operators.find(
        (op) => op._id === value
      );

      if (selectedOperator) {
        await db.operator.put({
          key: 'operatorId',
          value: selectedOperator._id,
        });
        await db.operator.put({
          key: 'name',
          value: selectedOperator.name,
        });
        setOperatorID(selectedOperator._id, selectedOperator.name);
      }
    }
  };

  // Generate dropdown options
  const options = [
    { value: '1', label: t('notSelected') },
    ...(operatorData?.operators?.map((op) => ({
      value: op._id,
      label: op.name,
    })) || []),
  ];

  return (
    <Select
      ref={dropdownRef}
      showSearch
      allowClear
      className="lg:min-w-[200px] min-w-8"
      loading={isLoading}
      optionFilterProp="label"
      options={options}
      placeholder={t('selectOperator')}
      value={operatorId} // Use operatorId from zustand
      onChange={handleSelectionChange}
      disabled={isRestrictedPage} // Disable dropdown for restricted paths
      filterSort={(optionA, optionB) =>
        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
      }
      onClear={async () => {
        if (isRestrictedPage) return;
        await db.operator.clear();
        setOperatorID(null, null);
      }}
    />
  );
};
